<template>
  <div class="receipe">
    <h1>
      La recette de Maïté
      <em>Miaaaaaaam !</em>
    </h1>
    <p>
      C'est les vacances ! Les enfants sont nombreux à nous lire, Maïté nous a donc concocté un
      petit délice qui ravira non les papilles, mais les méninges ! Nous mettons donc en pause notre
      série d'articles "Les dix meilleures recettes qui mélangent la crème, le gras de rillettes et
      la mimolette" pour nous consacrer à un exercice particulier : la cryptographie.
    </p>
    <p>
      <b>
        En tant qu'ex-espionne du KGB, Maïté vous propose aujourd'hui la découverte du Chiffre de
        Vigenère. L'outil indispensable de ce chiffrement est la « table de Vigenère » :
      </b>
    </p>
    <div class="center-text full-width">
      <img src="../../../assets/NewYear/vigenere.png" alt />
    </div>
    <p style="font-style:  italic">
      A l'aide de cette table, à partir de la phrase chiffrée, on regarde pour chaque lettre de la
      clé répétée la ligne correspondante et on y cherche la lettre chiffrée. La lettre de la
      colonne que l'on trouve ainsi est la lettre déchiffrée.
    </p>
    <p>Voici le chiffrement du jour :</p>
    <h3 class="center-text full-width">BCLHNIIC ZY LIVVGFY WO EVYUIG LFJPOCG JSIKWYK GPX</h3>
    <p>
      Il vous manque quelque chose ? Bien sûr, la clé ! Nous n'avons malheuresement pas
      l'autorisation de vous la divulguer. Nous vous laissons la réclamer directement à Maïté à
      l'adresse mail suivante :
    </p>
    <div class="center-text full-width">
      <a href="mailto:jaimelortolan@laposte.net" target="_blank">jaimelortolan@laposte.net</a>
    </div>
    <p>
      Vous pensez avoir la bonne réponse ? Le mot est à mettre au singulier et à nous envoyer par
      voie postale à la rédaction du journal pour tenter de gagner un tablier dédicacé par Maïtée !
    </p>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(hint, index) === 'inactive' "
        >💡 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>

<script>
import Hint from "../../shared/Hint";

export default {
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "receipe")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: "Playfair Display", serif;
  font-weight: bold;
  color: rgb(35, 35, 35);
  font-size: 300%;
  margin-top: 0;
  border-bottom: double rgb(35, 35, 35);
  width: 100%;
}
p,
a {
  color: rgb(35, 35, 35);
  font-family: "Playfair Display", serif;
  font-size: 16px;
}
em {
  font-size: 40%;
  color: #ebc134;
}
.full-width {
  width: 100%;
}
.center-text {
  text-align: center;
}
.receipe {
  font-family: "Playfair Display", serif;
}
.receipe img {
  max-width: 100%;
}
.hints {
  position: absolute;
  bottom: -3%;
  width: 82%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>
